import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'components/ProtectedRoute';
import CategoryList from '../pages/categories/Category.List';
import OrderList from '../pages/orders/Order.List';
import OrderDetail from '../pages/orders/Order.Detail';
import OrderAdd from '../pages/orders/Order.Add';
import SettingsPage from '../pages/settings/SettingsListPage';

// render- Dashboard
const Dashboard = Loadable(lazy(() => import('pages/dashboard')));

// render - Grocery Management
const Products = Loadable(lazy(() => import('pages/products')));
const Customers = Loadable(lazy(() => import('pages/customers')));
const DailyPriceUpdate = Loadable(lazy(() => import('pages/daily-update')));
const SendWhatsAppUpdate = Loadable(lazy(() => import('pages/send-update')));
const Profile = Loadable(lazy(() => import('pages/profile')));
const PreparationTime = Loadable(lazy(() => import('pages/preparedTime')));
const PriceHistory = Loadable(lazy(() => import('pages/price-history')));
const ProductPriceHistory = Loadable(lazy(() => import('pages/price-history/ProductHistory')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <ProtectedRoute />,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to="/dashboard" replace />
        },
        {
          path: 'dashboard',
          element: <Dashboard />
        },
        {
          path: 'dashboard/default',
          element: <Navigate to="/dashboard" replace />
        },
        {
          path: 'categories',
          element: <CategoryList />
        },
        {
          path: 'products',
          element: <Products />
        },
        {
          path: 'customers',
          element: <Customers />
        },
        {
          path: 'orders',
          element: <OrderList />
        },
        {
          path: 'order/create',
          element: <OrderAdd />
        },
        {
          path: 'orders/:orderId',
          element: <OrderDetail />
        },

        
        {
          path: 'daily-update',
          element: <DailyPriceUpdate />
        },
        {
          path: 'price-history',
          element: <PriceHistory />
        },
        {
          path: 'price-history/:productId',
          element: <ProductPriceHistory />
        },
        {
          path: 'send-update',
          element: <SendWhatsAppUpdate />
        },
        {
          path: 'profile',
          element: <Profile />
        },
        {
          path: 'preferred-time',
          element: <PreparationTime />
        },
        {
          path: 'settings',
          element: <SettingsPage />
        }
      ]
    }
  ]
};

export default MainRoutes;
